<template>
  <div class="text-sm font-medium text-gray-500">{{this.$t('statistics.messagesByChannel')}}</div>
  <apexchart v-if="showChannelsStatistics" height="380" type="donut" :options="messagesByChannelOptions" :series="messagesByChannelSeries"></apexchart>
</template>

<script>
import { useConversationsStore } from '@/stores/conversations'
import { useFanpagesStore } from '@/stores/fanpages';
import { useVonageStore } from '@/stores/vonageIntegrations';
import { useCustomerChannelStore } from '@/stores/customerChannels';
import messagesByChannelModel from '@/models/messages-by-channel'
import customerChannelModel from "@/models/customerChannel";

export default {
  name: 'MessagesByChannel',
  async created() {
    await this.fetchMessagesByChannel();
    await this.fetchCustomerChannels();
  },
  setup() {
    let conversationsStore = useConversationsStore();
    let fanpagesStore = useFanpagesStore();
    let vonageStore = useVonageStore();
    let customerChannelStore = useCustomerChannelStore();
    return { conversationsStore, fanpagesStore, vonageStore, customerChannelStore };
  },
  computed: {
    showChannelsStatistics() {
      return this.customerChannelStore.collection.length > 0;
    },
    messagesByChannelOptions() {
      let knownChannels = {};
      this.customerChannelStore.collection.forEach(ch => {
        knownChannels[ch.attributes.identifier] = {type: ch.attributes.type, identifier: ch.attributes.identifier, id: ch.id};
      });

      let labels = [];
      let colors = [];
      let counters = {
        'messenger': {counter: 0, 'colors': '66, 103, 178'},
        'instagram': {counter: 0, 'colors': '225, 48, 108'},
        'whatsapp': {counter: 0, 'colors': '18, 140, 126'},
      }
      if (this.messagesByChannel) {
        this.messagesByChannel.forEach(row => {
          let data = knownChannels[row['channel_identifier']];
          if (data) {
            colors.push(this.getChannelColor(data.type, counters));
            labels.push(this.getChannelName(data.identifier, data.type, data.id));
          }
        });
      }
      return {
        labels: labels,
        colors: colors,
        chart: {
          id: 'messages-by-channel',
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
              },
            },
          },
        },
        responsive: [{
          options: {
            legend: {
              show: false,
            },
          },
        }],
      };
    },
    messagesByChannelSeries() {
      let dataset = [];
      if (this.messagesByChannel) {
        this.messagesByChannel.forEach(row => {
          dataset.push(row['count']);
        });
      }
      return dataset;
    },
  },
  methods: {
    getChannelName(identifier, label, id) {
      if (label === 'messenger') {
        let fanpage = this.fanpagesStore.getByFanpageId(identifier);
        if (fanpage) {
          return fanpage.attributes.name;
        } else {
          return id;
        }
      }
      if (label === 'instagram') {
        let fanpage = this.fanpagesStore.getByFanpageInstagramAccountId(identifier);
        if (fanpage) {
          return fanpage.attributes['instagram-business-account']['data']['attributes']['name'];
        } else {
          return id;
        }
      }
      if (label === 'whatsapp') {
        let integration = this.vonageStore.getByPhoneNumber(identifier);
        if (integration) {
          return integration.attributes['name'];
        } else {
          return id;
        }
      }
      return id;
    },
    async fetchMessagesByChannel() {
      let dataset = await messagesByChannelModel.getMessagesByChannelStatistics(this.axios, this.$root.token);
      let resultSet = [];
      dataset.data.data.forEach(row => {
        let count = row.attributes['count'];
        resultSet.push({'channel_identifier': row.id, 'count': count});
      });
      resultSet.sort((a, b) => b.count > a.count);
      this.messagesByChannel = resultSet;
    },
    async fetchCustomerChannels() {
      let collection = [];
      this.conversationsStore.collection.forEach(c => {
        collection.push(c.customer_channel_ids);
      });
      if (collection && collection.length > 0) {
        collection.forEach(ids => {
          customerChannelModel.getCustomerChannelsByIds(this.axios, this.$root.token, ids).then(response => {
            response.data.data.forEach(customerChannel => {
              this.customerChannelStore.replaceOrAdd(customerChannel);
            });
          });
        });
      }
    },
    getChannelColor(type, counters) {
      let opacity;
      let option = counters[type];
      if (option) {
        opacity = this.getColorOpacity(type, counters);
        return `rgba(${option.colors}, ${opacity})`;
      }
      return 'rgb(236, 178, 46)';
    },
    getColorOpacity(type, counters) {
      let count = counters[type].counter;
      counters[type].counter++;
      let result = 1 - count/8;
      if (result < 0.1) {
        return 0.1;
      } else {
        return result;
      }
    }
  },
  data() {
    return {
      'messagesByChannel': undefined,
    }
  },
}
</script>
